/**
 * Returns true when the app is in the foreground:
 *   document.visibilityState === 'visible' && document.hasFocus()
 *
 * Both conditions must hold (matches NotificationContext.js convention).
 * Synchronous DOM read at call site — no React state, no caching — so
 * callers see the live value at the moment of the decision (e.g. inside
 * a debounce timer callback that fires after a blur).
 */
export function isAppInForeground() {
  if (typeof document === 'undefined') return true;
  const visible = document.visibilityState === 'visible';
  const focused = typeof document.hasFocus === 'function' ? document.hasFocus() : true;
  return visible && focused;
}
